<template>
  <div class="el-input">
    <div style="width:10em; float: left" ><el-input :value="amount" @input="changeAmount($event)" style="width:10em" /></div>
    <el-select :value="unit" value-key="key" :size="size" @input="change($event)" style="width:10em">
      <el-option label="年" value="Y" />
      <el-option label="月" value="M" />
      <el-option label="天" value="D" />
    </el-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      amount: 30,
      unit: 'D'
    }
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    changeAmount: function (val) {
      this.amount = val
      this.$emit('input', '' + this.amount + this.unit)
    },
    change: function (val) {
      this.unit = val
      this.$emit('input', '' + this.amount + this.unit)
    }
  },
  mounted () {
    if (!this.value) {
      this.$emit('input', '' + this.amount + this.unit)
      return
    }
    let data = /([0-9]+)((Y|M|D))/.exec(this.value)
    if (data) {
      this.amount = data[1]
      this.unit = data[2]
    }
  },
  watch: {
    value (val) {
      let data = /([0-9]+)((Y|M|D))/.exec(val)
      if (data) {
        this.amount = data[1]
        this.unit = data[2]
      } else {
        this.amount = '30'
        this.unit = 'D'
      }
      this.$emit('input', '' + this.amount + this.unit)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/PackageDurationSelect.vue